export const OPTIONTRADE_LIST_ATTEMPT = "OPTIONTRADE_LIST_ATTEMPT";
export const OPTIONTRADE_LIST_SUCCESS = "OPTIONTRADE_LIST_SUCCESS";
export const OPTIONTRADE_LIST_FAILED = "OPTIONTRADE_LIST_FAILED";

